// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveSelectItem_base--26lqf","reserveWrapper":"ReserveSelectItem_reserveWrapper--1ZmKr","content":"ReserveSelectItem_content--1hwl5","reserve":"ReserveSelectItem_reserve--iyVNj","divider":"ReserveSelectItem_divider--1Mkcd","highlighted":"ReserveSelectItem_highlighted--3sU_i","status":"ReserveSelectItem_status--2r2o9","status__inProgress":"ReserveSelectItem_status__inProgress--_OhOQ","statusInProgress":"ReserveSelectItem_status__inProgress--_OhOQ"};


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingCard/components/ReserveSelect/components/ReserveSelectItem/ReserveSelectItem.scss
// module id = 2122
// module chunks = 11